// extracted by mini-css-extract-plugin
export var decorationBar = "Decoration-module--decorationBar--6jmjr";
export var decorationChildren = "Decoration-module--decorationChildren--xI61B";
export var root = "Decoration-module--root--wZy9x";